import * as env from '@/config/env';

/**
 * 
 * @param {Type of request} type 
 * @param {In which bucket file upload} bucketId 
 * @param {FilePath} path 
 * @returns Object with Routes and metadata
 */
export const storageQueryBuilder = (type,bucketId,path) => {
    const storageType = String(env.STORAGE_TYPE || 'wasabi').toLowerCase();

    if(type == 'upload') {
        if(storageType === 'server') {
            return {
                route:env.UPLOAD_FILE,
            };
        } else if(storageType === 's3') {
            return {
                route: env.S3_UPLOAD_FILE,
            };
        } else {
            return {
                route:env.WASABI_UPLOAD_FILE
            };
        }
    } else if(type == 'get') {
        if(storageType === 'server') {
            return {
                route:env.GET_SIGNED_OR_PUBLIC_URL + "/" + bucketId + "?filepath=" + path + "&domainUrl=" + env.DOMAIN_URI,
                method: 'get',

            };
        } else if(storageType === 's3') {
            return {
                route: env.S3_RETRIVE_OBJECT
            };
        } else {
            return {
                route:env.WASABI_RETRIVE_OBJECT
            };
        }
    }  else if(type == 'delete') {
        if(storageType === 'server') {
            return {
                route:env.REMOVE_FILE + '/' + bucketId + '?filepath=' + path,
                data: {},
                method: 'delete',
            };
        } else if(storageType === 's3') {
            return {
                route: env.S3_DELETE_FILE,
                data: {
                    companyId: bucketId,
                    path: path
                },
                method: 'post',
            };
        } else {
            return {
                route:env.WASABI_DELETE_FILE,
                data: {
                    companyId: bucketId,
                    path: path
                },
                method: 'post',
            };
        }
    } else if(type == 'upload_64') {
        if(storageType === 'server') {
            return {
                route:env.UPLOAD_FILE_64,
            };
        } else if(storageType === 's3') {
            return {
                route: env.S3_UPLOAD64_FILE
            };
        } else {
            return {
                route:env.WASABI_UPLOAD64_FILE
            };
        }
    }
}

export const generateFileName = (originalName, storageType) => {
    const randomNumber = parseInt(Date.now() * Math.random());
    let newName = originalName.replaceAll(" ", "_");

    if (storageType && storageType === 'server') {
        newName = newName.replaceAll(/[^a-zA-Z0-9_\-./]/g, '_');
    }

    return `${randomNumber}_${newName}`;
}
